<template>
  <section class="dept-about dept-modern__section">
    <div class="dept-modern">
      <div class="dept-about__card dept-modern__card">
        <h2 v-if="heading" class="dept-modern__title">{{ heading }}</h2>
        <p v-if="text" class="dept-about__text">{{ text }}</p>
        <div v-if="stats.length" class="dept-about__stats">
          <div v-for="(stat, idx) in stats" :key="idx" class="dept-about__stat">
            <div class="dept-about__stat-icon" aria-hidden="true">
              <img
                v-if="iconSrc(stat)"
                class="dept-about__stat-img"
                :src="iconSrc(stat)"
                alt=""
              >
              <svg v-else viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/></svg>
            </div>
            <span class="dept-about__stat-label">{{ stat.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { departmentStatIconSrc } from '@/helpers/departmentStatIcons'

export default {
  name: 'DepartmentAbout',
  props: {
    heading: { type: String, default: '' },
    text: { type: String, default: '' },
    stats: { type: Array, default: () => [] },
  },
  methods: {
    iconSrc: departmentStatIconSrc,
  },
}
</script>

<style scoped lang="scss">
.dept-about__card {
  padding: 32px 36px;

  @media (max-width: 767.98px) {
    padding: 24px 20px;
  }
}

.dept-about__text {
  margin: 0 0 28px;
  font-family: "Circe", sans-serif;
  font-size: 17px;
  line-height: 1.65;
  color: #2d3436;
  white-space: pre-line;
}

.dept-about__stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding-top: 8px;
  border-top: 1px solid #e8ece8;

  @media (max-width: 767.98px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

.dept-about__stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
}

.dept-about__stat-icon {
  width: 88px;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: transparent;
  color: #66cc66;
  overflow: hidden;

  svg {
    width: 40px;
    height: 40px;
  }
}

.dept-about__stat-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.dept-about__stat-label {
  font-family: "Circe", sans-serif;
  font-size: 15px;
  line-height: 1.35;
  color: #2d3436;
}
</style>
